import _toConsumableArray from "/mnt/sdb/frontend/ibus/app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "/mnt/sdb/frontend/ibus/app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _defineProperty from "/mnt/sdb/frontend/ibus/app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import React, { useEffect, useMemo, useCallback } from 'react';
import isUndefined from 'lodash/isUndefined';
import isObject from 'lodash/isObject';
import isNull from 'lodash/isNull';
import classnames from 'classnames';
import { FormControl, FormControlLabel, FormGroup, FormLabel, Checkbox as MuiCheckbox, FormHelperText, Typography, Collapse, IconButton } from '@material-ui/core';
import { ExpandLess, ExpandMore, CheckBoxOutlineBlank, CheckBox } from '@material-ui/icons';
import isArray from 'lodash/isArray';
export var getColumnsStyles = function getColumnsStyles(columns) {
  var styles = {};

  if (isObject(columns)) {
    styles.columns = columns.count;

    if ('gap' in columns) {
      styles.columnGap = columns.gap;
    }

    if ('rule' in columns) {
      styles.columnRule = columns.rule;
    }
  } else {
    styles.columns = columns;
  }

  return styles;
};

var renderFormGroup = function renderFormGroup(ID, values, onChange, field, classes, isColumns, isManageAll, disabled, slim) {
  var asSlim = !!slim || isManageAll;
  return React.createElement(FormGroup, {
    className: classnames(classes.checkGroup, _defineProperty({}, classes.slimCheckGroup, !!slim)),
    row: true
  }, React.createElement("div", {
    style: isColumns ? getColumnsStyles(field.columns) : undefined
  }, !isUndefined(field.items) ? field.items.map(function (item, index) {
    var valueName = item.value;
    return React.createElement(FormControlLabel, {
      key: index,
      label: item.label,
      className: classnames(classes.checkGroupControlLabel, isColumns ? classes.checkGroupColumnControlLabel : ''),
      classes: {
        label: classnames(classes.checkLabel, _defineProperty({}, classes.slimCheckLabel, !!slim))
      },
      control: React.createElement(MuiCheckbox, {
        className: classes.checkGroupControl,
        id: "".concat(ID, "_").concat(index),
        checked: values.includes(valueName),
        disabled: disabled,
        onChange: onChange(valueName),
        // в chrome появляется баг с колонками при условии полного заполнения колонок элементами,
        // когда при клике на первый элемент 2й и следующих колонок с transition,
        // этот элемент съезжает на следующую колонку
        // https://bugs.chromium.org/p/chromium/issues/detail?id=460222
        disableRipple: isColumns,
        icon: React.createElement(CheckBoxOutlineBlank, {
          fontSize: asSlim ? 'small' : 'default'
        }),
        checkedIcon: React.createElement(CheckBox, {
          fontSize: asSlim ? 'small' : 'default'
        }),
        value: valueName,
        color: 'primary',
        classes: {
          root: asSlim ? classes.slimCheckControl : classes.baseCheckControl
        }
      })
    });
  }) : null));
};

export default function CheckboxGroup(props) {
  var id = props.id,
      required = props.required,
      field = props.field,
      value = props.value,
      error = props.error,
      onFieldChange = props.onFieldChange,
      classes = props.classes,
      disabled = props.disabled,
      slim = props.slim;
  var ID = id || field.name;
  var isColumns = !!field.columns;
  var isCollapse = 'collapse' in field;
  var isManageAll = field.manageAll;
  /** Устанавливаемое значение*/

  var selectedValues = useMemo(function () {
    return isArray(value) && value.length > 0 ? value : [];
  }, [value]);
  var items = useMemo(function () {
    return field.items && isArray(field.items) ? field.items : [];
  }, [field.items]);
  var getCheckAllState = useCallback(function (values) {
    var itemsLength = items.length;
    var state = null;

    if (itemsLength) {
      if (items.every(function (item) {
        return values.includes(String(item.value));
      })) {
        state = true;
      } else if (values.length === 0) {
        state = false;
      }
    }

    return state;
  }, [items]);

  var _React$useState = React.useState(isCollapse ? !field.collapse : true),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      opened = _React$useState2[0],
      setOpened = _React$useState2[1];

  var _React$useState3 = React.useState(getCheckAllState(selectedValues)),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      checkAll = _React$useState4[0],
      setCheckAll = _React$useState4[1];

  useEffect(function () {
    setCheckAll(getCheckAllState(selectedValues));
  }, [getCheckAllState, selectedValues]);

  var onChange = function onChange(name) {
    return function (event) {
      var newValues = event.target.checked ? [].concat(_toConsumableArray(selectedValues), [name]) : selectedValues.filter(function (valueName) {
        return valueName !== name;
      });
      setCheckAll(getCheckAllState(newValues));
      onFieldChange(ID, newValues);
    };
  };
  /**
   * Открытие/скрытие группы
   */


  var toggleOpened = function toggleOpened() {
    setOpened(!opened);
  };
  /**
   * Массовое управление
   * @param event
   * @param checked
   */


  var toggleCheckAll = function toggleCheckAll(event, checked) {
    setCheckAll(checked);
    var newValues = checked ? field.items.map(function (item) {
      return item.value;
    }) : [];
    onFieldChange(ID, newValues);
  };

  var formGroupComponent = renderFormGroup(ID, selectedValues, onChange, field, classes, isColumns, isManageAll, disabled, slim);
  return React.createElement(FormControl, {
    required: !!required,
    error: !!error,
    component: 'fieldset'
  }, React.createElement(FormLabel, {
    component: 'legend',
    classes: {
      root: classes.checkGroupLabel,
      focused: classes.checkGroupLabelFocused
    }
  }, React.createElement(Typography, {
    variant: slim ? 'body2' : 'body1',
    display: 'inline'
  }, isManageAll && React.createElement(MuiCheckbox, {
    className: classnames(classes.checkGroupCheckbox, _defineProperty({}, classes.slimCheckGroupCheckbox, slim)),
    checked: !isNull(checkAll) && checkAll,
    value: 'checkAll',
    onChange: toggleCheckAll,
    indeterminate: isNull(checkAll),
    color: 'primary',
    icon: React.createElement(CheckBoxOutlineBlank, {
      fontSize: slim ? 'small' : 'default'
    }),
    checkedIcon: React.createElement(CheckBox, {
      fontSize: slim ? 'small' : 'default'
    })
  }), field.label, isCollapse && React.createElement(IconButton, {
    onClick: toggleOpened,
    size: 'small',
    edge: 'end'
  }, opened ? React.createElement(ExpandLess, {
    fontSize: slim ? 'small' : 'default'
  }) : React.createElement(ExpandMore, {
    fontSize: slim ? 'small' : 'default'
  })))), isCollapse ? React.createElement(Collapse, {
    in: opened
  }, formGroupComponent) : formGroupComponent, !!error && React.createElement(FormHelperText, {
    className: classnames(_defineProperty({}, classes.slimHelperText, !!slim))
  }, error));
}